module.exports = __webpack_public_path__ + "img/secure_private.88ecba8a.jpg";